import React from 'react';

export const RadioCheck = (props: { fill?: string }) => {
  return (
    <svg width='44' height='44' viewBox='0 0 44 44' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect opacity='0.01' width='44' height='44' fill='#FF0000' />
      <rect x='6' y='6' width='32.3636' height='32' rx='16' fill={props.fill || '#4957F4'} />
      <path
        d='M29.8749 16.4844L18.219 28.5716L13.7344 23.6082'
        stroke='white'
        strokeWidth='1.75'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};
